import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Gauge, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "itsp_check_promo_dismissed_v1";
const HIDE_ON = ["/webseiten-check"];

export const CheckPromoBar = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (HIDE_ON.includes(pathname)) return;

    let dismissed = false;
    try {
      dismissed = !!localStorage.getItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    if (dismissed) return;

    // delay reveal so cookie consent gets focus first
    const t = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(t);
  }, [pathname]);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;
  if (pathname.startsWith("/admin")) return null;
  if (HIDE_ON.includes(pathname)) return null;

  return (
    <div
      data-testid="check-promo-bar"
      role="region"
      aria-label="Webseiten-Check Promotion"
      className="fixed bottom-0 left-0 right-0 z-40 animate-fade-up"
    >
      <div className="bg-ink text-white border-t border-accent/40 shadow-glow">
        <div className="max-w-7xl mx-auto px-4 sm:px-12 py-3 sm:py-3.5 flex items-center gap-3 sm:gap-6">
          {/* Icon */}
          <div className="hidden sm:flex w-10 h-10 shrink-0 bg-accent/15 border border-accent/40 items-center justify-center text-accent">
            <Gauge size={20} />
          </div>

          {/* Text */}
          <div className="flex-1 min-w-0">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-accent">
              Kostenlos · 60 Sekunden · keine Anmeldung
            </div>
            <div className="mt-0.5 font-display font-bold text-sm sm:text-base text-white truncate">
              <span className="hidden sm:inline">Wie steht Ihre Webseite bei Google da? </span>
              <span className="sm:hidden">Webseiten-Check </span>
              <span className="text-white/70 hidden md:inline">Score, Detail-Report & Empfehlungen.</span>
            </div>
          </div>

          {/* CTA */}
          <Link
            to="/webseiten-check"
            data-testid="check-promo-bar-cta"
            onClick={dismiss}
            className="group inline-flex items-center justify-center gap-2 px-4 sm:px-6 py-2 sm:py-2.5 bg-accent text-ink text-sm font-medium hover:bg-accent/90 transition-colors shrink-0"
          >
            <span className="hidden sm:inline">Jetzt prüfen</span>
            <span className="sm:hidden">Prüfen</span>
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>

          {/* Dismiss */}
          <button
            onClick={dismiss}
            data-testid="check-promo-bar-dismiss"
            aria-label="Hinweis schließen"
            className="p-2 text-white/50 hover:text-white transition-colors shrink-0"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};
